import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IBankTabChangeEvent } from "./bank-tab-change-event.interface";

@Component({
	template: '',
})
export abstract class BankBaseTabPageComponent {
	@Input() readOnly: boolean = true;
	@Output() tabChange = new EventEmitter<IBankTabChangeEvent>();
}
